export default "__VITE_ASSET__BY$g2DBF__"